import {
  parseString,
  processors,
} from 'xml2js';

// Processors to modify the tag and attribute names of the XML
const nameProcessors = [
  processors.stripPrefix,
  processors.firstCharLowerCase,
];

// Processors to modify the body and attribute values of the XML
const valueProcessors = [
  processors.parseNumbers,
  processors.parseBooleans,
];

// Options for xml2js parseString
const parserOpts = {
  explicitArray: false,
  tagNameProcessors: nameProcessors,
  attrNameProcessors: nameProcessors,
  valueProcessors,
  attrValueProcessors: valueProcessors,
};

/**
 * Parse a string of XML into a Javascript object.
 * @param {string} xmlText The XML string
 * @returns {Promise<any>} Resolves with the resulting JS object
 */
// eslint-disable-next-line import/prefer-default-export
export function xmlToJs(xmlText) {
  return new Promise((resolve, reject) =>
    parseString(xmlText, parserOpts, (err, result) => (
      err ? reject(err) : resolve(result)
    )),
  );
}



// WEBPACK FOOTER //
// ./utils/xml.js